import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

export class AbMutationObserver {
  constructor(callback) {
    _defineProperty(this, "_observer", void 0);
    _defineProperty(this, "_callback", void 0);
    _defineProperty(this, "_element", void 0);
    /**
     * Stop observing.
     */
    _defineProperty(this, "disconnect", () => {
      this._element = null;
      this._observer.disconnect();
    });
    /**
     * Observe a new target. By default, observe the subtree of changes to child nodes and character data.
     *
     * Note that if you observe a node's subtree, a MutationObserver will continue to observe DOM nodes that
     * are removed from the parent node & re-added elsewhere.
     * See this article for more info:
     * https://www.smashingmagazine.com/2019/04/mutationobserver-api-guide/#moving-a-node-tree-that-s-being-observed
     */
    _defineProperty(this, "observe", (target, options) => {
      this.disconnect();
      this._element = target;
      this._observer.observe(target, options ?? {
        subtree: true,
        childList: true,
        characterData: true
      });
    });
    this._element = null;
    this._callback = callback;
    this._observer = new MutationObserver(() => {
      this.callCallback();
    });
  }
  callCallback() {
    if (!this._element) return;
    this._callback(this._element);
  }
  set callback(newCallback) {
    this._callback = newCallback;
  }
  get callback() {
    return this._callback;
  }
  get observedElement() {
    return this._element;
  }
}
//# sourceMappingURL=AbMutationObserver.js.map
